import { render } from "./BaseTable.vue?vue&type=template&id=45622cd6"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=45622cd6&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/pinenativeWeb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__